import { useEffect, useState } from "react";
import { useNavigate } from "@usas/ui-web/wrappers/ReactRouterDom";

import NavLinks from "../../NavLinks";

import useGroupData from "@usas/ui-web/state/group/UseGroupData";
import useMemberGroupsData from "@usas/ui-web/state/memberGroups/UseMemberGroupsData";
import useGroupFieldNamesData from "@usas/ui-web/state/groupFieldNames/UseGroupFieldNamesData";

import { DEFAULT_ID } from "@usas/ui-web/utils/Constants";

const INITIAL_MODAL_STATE = {
  displayModal: false,
  personOrgGroupId: DEFAULT_ID,
  firstName: '',
  lastName: '',
};

const useGroupCampMembers = () => {
  const navigate = useNavigate();
  const { GROUP_CONSTANTS } = useGroupFieldNamesData();
  const { groupState, groupMembersState, getGroupMembers } = useGroupData();
  const { memberGroupsState, deleteGroupMember, resetMemberGroupsState } = useMemberGroupsData();
  const [gridState, setGridState] = useState([]);
  const [modalState, setModalState] = useState(INITIAL_MODAL_STATE);

  const onAddMemberToGroupClicked = () => {
    navigate(NavLinks.GROUP_MEMBERS_ADD);
  };

  const onInviteAlternateClicked = () => {
    navigate(NavLinks.GROUP_MEMBERS_INVITE_ALTERNATE);
  };

  const onInviteAlternateIMXClicked = () => {
    navigate(NavLinks.GROUP_MEMBERS_INVITE_ALTERNATE_IMX);
  };

  const onEditGroupMemberClicked = (member) => {
    navigate(NavLinks.GROUP_MEMBERS_EDIT, { state: { member } });
  };

  const onDeleteModalConfirmClicked = async (event) => {
    event?.preventDefault();
    
    const personOrgGroupId = modalState.personOrgGroupId;

    setModalState({ ...INITIAL_MODAL_STATE });

    const deleteGroupMemberResult = await deleteGroupMember(personOrgGroupId);

    if (deleteGroupMemberResult) {
      resetMemberGroupsState();
      setGridState([]);

      const getGroupMemberResult = await getGroupMembers(groupState.objData.orgGroupId);

      if (getGroupMemberResult) {
        setGridState(createMemberGridState(getGroupMemberResult.arrayData || []));
      }
    }
  };

  const onDeleteModalCancelClicked = () => {
    setModalState({ ...INITIAL_MODAL_STATE });
  };

  const onDeleteGroupMemberClicked = (member) => {
    setModalState({
      ...modalState,
      displayModal: true,
      firstName: member.firstName,
      lastName: member.lastName,
      personOrgGroupId: member.personOrgGroupId
    });
  };

  useEffect(() => {
    if (groupMembersState.isArrayLoaded === true) {
      setGridState(createMemberGridState(groupMembersState.arrayData || []));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function createMemberGridState(arrayData) {
    const newGridData = [];

    for (const member of arrayData) {
      newGridData.push({
        personId: member.personId,
        firstName: member.firstName,
        lastName: member.lastName,
        eventName: member.eventName,
        personOrgGroupId: member.personOrgGroupId,
        coachOfRecord: Array.isArray(member.personGroupTypeField)
          ? getCoachOfRecordName(member.personGroupTypeField.find(x => x.fieldName === GROUP_CONSTANTS.PERSON_GROUP_TYPE_FIELD_NAME_COACH_OF_RECORD))
          : undefined,
        groupAttendeeType: Array.isArray(member.personGroupTypeField)
          ? member.personGroupTypeField.find(x => x.fieldName === GROUP_CONSTANTS.PERSON_GROUP_TYPE_FIELD_NAME_ATTENDEE_TYPE)?.fieldValue
          : undefined,
        selectionStatus: member.personOrgGroupQualificationStatus
      });
    }

    return newGridData;
  }

  function getCoachOfRecordName(coachOfRecordField) {
    if (coachOfRecordField) {
      return `${coachOfRecordField.coachFirstName || ''} ${coachOfRecordField.coachLastName || ''}`;
    } else {
      return undefined;
    }
  }

  return {
    isLoading: groupMembersState.isArrayLoading,
    isSaving: memberGroupsState.isSaving,
    gridData: gridState,
    modalState,
    onAddMemberToGroupClicked,
    onInviteAlternateClicked,
    onInviteAlternateIMXClicked,
    onEditGroupMemberClicked,
    onDeleteGroupMemberClicked,
    onDeleteModalConfirmClicked,
    onDeleteModalCancelClicked
  };
};

export default useGroupCampMembers;